import { stdObject } from "../../../../data/types/stdObject";

export const filterValues = (data: stdObject) => {
  let tempResults = data.results;
  [
    ["PERHIS", "userCode"],
    ["AREHIS", "type"],
    ["ACNHIS", "observ"],
    ["CODHIS", "code"],
    ["NOMHIS", "name"],
  ].forEach((e) => {
    if (data[e[0]].value.trim() !== "") {
      tempResults = tempResults.filter((o: stdObject) =>
        e[1] in o && ["string", "number"].includes(typeof o[e[1]])
          ? ["CODHIS", "NOMHIS"].includes(e[0])
            ? typeof o[e[1]] === "string" &&
              o[e[1]]
                .toLowerCase()
                .toString()
                .includes(data[e[0]].value.trim().toLowerCase())
            : o[e[1]].toString() === data[e[0]].value
          : data[e[0]].value === "undefined" && !o[e[1]],
      );
    }
  });
  return tempResults;
};
